let _ = t => t,
  _t;
import styledWithTheme, { isTrellisTheme } from 'foundations-theming/utils';
export const HighlightedText = styledWithTheme.span(_t || (_t = _`
  font-weight: ${0};
  padding: 0 1px;
  margin: 0 0.5px;
  background: ${0};
`), ({
  theme
}) => theme.typography['body-125'].fontWeight, ({
  theme
}) => isTrellisTheme(theme) ? theme.color['fill-accent-yellow-subtle'] : theme.color['fill-accent-yellow-default']);